import { Outlet } from "react-router-dom"
import { LocationsProvider } from "./LocationsProvider"
import { SitesProvider } from "./SitesProvider"
import { ForecastProvider } from "./ForecastProvider"
import { PreferencesProvider } from "./PreferencesProvider"
import { ToastProvider } from "./ToastProvider"
import { DashboardUser } from "@hydrologiq/common/providers/FirebaseAuth"
import { QueryProvider } from "./QueryProvider"
import React from "react"

function Providers({
  children,
  user,
  locationsProvider = true,
  forecastProvider = true,
  sitesProvider = true,
}: {
  children?: React.ReactNode
  container?: React.RefObject<HTMLElement>
  user?: DashboardUser
  locationsProvider?: boolean
  forecastProvider?: boolean
  sitesProvider?: boolean
}) {
  const LocationsProviderComponent = locationsProvider ? LocationsProvider : React.Fragment
  const ForecastProviderComponent = forecastProvider ? ForecastProvider : React.Fragment
  const SitesProviderComponent = sitesProvider ? SitesProvider : React.Fragment
  return (
    <ToastProvider>
      <QueryProvider user={user}>
        <LocationsProviderComponent>
          <ForecastProviderComponent>
            <PreferencesProvider>
              <SitesProviderComponent>{children || <Outlet />}</SitesProviderComponent>
            </PreferencesProvider>
          </ForecastProviderComponent>
        </LocationsProviderComponent>
      </QueryProvider>
    </ToastProvider>
  )
}

export default Providers
